import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetArticleList, EResetArticleListActionType } from './types';

export const resetArticleList: () => TResetArticleList = actionGenerator<EResetArticleListActionType.Reset>(
  EResetArticleListActionType.Reset,
);
